// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7536) return "static/chunks/7536-c154bca1d07e41e8.js";
	if (chunkId === 2196) return "static/chunks/ee8b1517-88c3f2f124110d87.js";
	if (chunkId === 9421) return "static/chunks/9421-d33052f6fd3998d5.js";
	if (chunkId === 3539) return "static/chunks/3539-cce12ce14473e9ca.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1819":"798ddde6f1605fa5","2415":"5a529edc943c4e38","3119":"f6f50b0514ad1e84","5908":"c0365879a7d7c815","6721":"e7a05f6db72b0668","7368":"cfd96c687fe7a710","8871":"faf559c47a652881","9319":"bb5f2e2fa10cc014"}[chunkId] + ".js";
};